import Chart from "react-apexcharts";
import { Spin } from "antd";
import EmptyBox from "../../../ui/EmptyBox";
import React from "react";
import styles from "../../../styles/Components/charts/PieChart.module.css";

const getLabel = (item) => {
  if (item?.SYMBOL_NAME) {
    return `${item?.SYMBOL_NAME}/${item?.MARKET_TYPE}`;
  } else {
    const marketType = item?.assetName !== "USDT" ? "/Crypto" : "";
    return `${item?.assetName}${marketType}`;
  }
};

const colors = ["#0D4AF9", "#94B3FF", "#5E91FF", "#1C338C"];

const PieChart = ({ chartData, loading, style = {}, height = 400 }) => {
  const labels = chartData ? chartData.map(getLabel) : ["no data"];

  const series = chartData
    ? chartData?.map(
        (item) =>
          item?.USD_AMOUNTS ||
          Number(item?.availableBalanceUSD ?? 0) +
            Number(item?.stakingBalanceUSD ?? 0),
      )
    : [100];

  let data = {
    series,
    options: {
      chart: {
        type: "donut",
      },
      colors,
      labels,
      stroke: {
        colors: ["#fff"],
      },
      fill: {
        type: "gradient",

        opacity: 0.8,
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val.toFixed(0) + "%";
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            // chart: {
            //   width: 200,
            // },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
      plotOptions: {
        pie: {
          donut: {
            size: "80%",
          },
        },
      },
      legend: {
        show: false,
        position: "right",
        fontSize: "13px",
        fontWeight: 500,
        labels: {
          useSeriesColors: true,
        },
        markers: {
          width: 10,
          height: 10,
          radius: 2,
        },
        itemMargin: {
          vertical: 4,
        },
      },
    },
  };

  return (
    <div style={style}>
      <Spin spinning={loading}>
        {chartData?.length > 0 ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Chart
              options={data.options}
              series={data.series}
              type="donut"
              height={300}
              width={300}
            />
            <div className={styles.labels}>
              {labels.map((label, idx) => (
                <div
                  key={idx}
                  className={styles.label}
                  style={{
                    backgroundColor: colors[idx % colors.length],
                  }}
                >
                  {label}
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <EmptyBox useCase="analytic" size={80} />
          </div>
        )}
      </Spin>
    </div>
  );
};

export default PieChart;

//<Chart
//             options={data.options}
//             series={data.series}
//             type="donut"
//             height={height}
//             width={"100%"}
//           />
